var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"small font-italic text-muted mx-2"},[_vm._v("\n  (Atualizado em "+_vm._s(_vm.date ? _vm.$moment(_vm.date ).format(_vm.format) : '...')+" "),_c('i',{staticClass:"fas fa-clock"}),_vm._v(")\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }